/** Truncate display name — full name available via title tooltip */
export function truncateStaffName(firstName, lastName, maxLen = 20) {
  const full = `${firstName || ""} ${lastName || ""}`.trim();
  if (!full) return { display: "—", full: "" };
  if (full.length <= maxLen) return { display: full, full };
  return { display: `${full.slice(0, maxLen)}...`, full };
}
